import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

export const DarkCard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        mt: 2,
        mb: 2,
        width: "100%",
        backgroundColor: "#E5E4E2",
        borderRadius: "20px",
      }}
    >
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
}